/* global FERRET_HOST */

import React from 'react';
import OmioFerret from '@goeuro/app/client/ferret/src/entries/index';

import { Container } from 'components/shared/container/Container.styled';
import * as Styled from './Ferret.styled';
import { FerretProps } from './Ferret.props';
import useFerretData from './hooks/useFerretData';
import type { FerretData } from './hooks/useFerretData';
import { FERRET_ID } from './contants';

interface FerretViewProps extends FerretProps {
  data: FerretData;
}

export function FerretView({
  data,
  translations,
  margin,
  theme,
}: FerretViewProps): React.ReactElement | null {
  const {
    abTestParameters,
    arrivalId,
    currency,
    departureId,
    isMobile,
    locale,
    partnerId,
    prefillProps,
    travelModes,
  } = data;
  const searchOptions = { host: FERRET_HOST };
  const backgroundColor = theme?.backgroundColor || '';

  if (!translations) return null;

  const ferretProps = {
    slim: false,
    locale,
    currency,
    travelMode: travelModes,
    isRebrand: true,
    hidePassengerCopy: true,
    translations,
    partnerId,
    formAction: `${FERRET_HOST}/GoEuroAPI/rest/api/v5/searches`,
    searchOptions,
    abTestParameters,
    departureId,
    arrivalId,
    useMobilePanels: isMobile,
    ...prefillProps,
  };

  return (
    <Styled.Wrapper backgroundColor={backgroundColor}>
      <Container>
        <Styled.FerretWrapper
          margin={margin}
          isMobile={isMobile}
          data-e2e="wlSearchBar"
        >
          <div>
            <OmioFerret id={FERRET_ID} {...ferretProps} />
          </div>
        </Styled.FerretWrapper>
      </Container>
    </Styled.Wrapper>
  );
}

function Ferret(props: FerretProps): React.ReactElement | null {
  const data = useFerretData();
  return <FerretView {...props} data={data} />;
}

export default Ferret;
